"use client";

import { motion } from "framer-motion";
import { Check, ChevronRight, Crown, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
const standardFeatures = ["Basic public course information", "Course Finder and destination visibility", "Official website where available", "Free factual corrections"];
const partnerFeatures = ["Managed premium presentation", "Approved imagery and brand positioning", "Traveller-ready visitor information", "Preferred enquiry or booking pathway", "Priority updates", "Selected campaign and destination opportunities"];
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 28
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      ease: "easeOut"
    }
  }
};
export default function CoursePartnershipComparison() {
  const scrollToEnquiry = () => {
    document.getElementById("partner-enquiry")?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  return <section id="partner-benefits" className="w-full overflow-hidden bg-[#F7F3E9] ![padding:60px_32px_60px_32px] !h-[750px]" style={{
    fontFamily: '"Raleway", Arial, sans-serif'
  }}>
      <div className="mx-auto w-full max-w-[1180px]">
        {}
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.55,
        ease: "easeOut"
      }} className="mx-auto max-w-[860px] text-center">
          <p className="font-bold uppercase tracking-[0.18em] text-[#9A793A] !text-xs">
            Standard Presence vs Partnership
          </p>

          <h2 className="mt-4 text-[40px] leading-[1.06] tracking-[-0.035em] text-[#073F31] !font-semibold md:text-[50px] lg:text-[58px]" style={{
          fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
        }}>
            Every course can be discovered.
            <br />
            <span className="italic font-normal text-[#426A5D]"><span className="text-primary"><span className="text-primary"><span className="text-foreground"><span className="text-primary"><span className="text-muted-foreground"><span className="!font-semibold">Partners go further.</span></span></span></span></span></span></span>
          </h2>

          <p className="max-w-[760px] text-[15px] leading-[1.7] text-[#65746D] ![margin:10px_50px_0px_50px] md:text-[16px]">
            Standard presence is free. Partnership gives your team greater
            control, presentation and opportunities to reach the next generation
            of golf travellers.
          </p>
        </motion.div>

        {}
        <div className="relative mt-12 lg:mt-14">
          <div className="grid grid-cols-1 gap-7 ![margin:-30px_0px_-30px_0px] !h-[380px] lg:grid-cols-[1fr_64px_1fr] lg:items-stretch">
            {}
            <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{
            once: true,
            amount: 0.2
          }} className="!h-[360px]">
              <div className="overflow-hidden border border-[#E5DED1] bg-[#FFFDF7] rounded-tl-[20px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] !h-[360px]">
                {}
                <div className="flex items-center gap-3 border-b border-[#ECE5D9] bg-[#F3F1EC] px-7 py-4 !justify-center">
                  <MapPin className="size-[20px] text-[#9A793A]" strokeWidth={1.7} />
                  <h3 className="text-[18px] font-medium leading-none text-[#1E2C28] md:text-[20px]" style={{
                  fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
                }}>
                    Standard Course Presence
                  </h3>
                </div>

                <div className="flex h-[calc(100%-65px)] flex-col px-7 py-6 md:px-8 md:py-7">
                  <ul className="space-y-4 ![margin:-10px_0px_-10px_0px]">
                    {standardFeatures.map(feature => <li key={feature} className="flex items-start gap-3 !justify-start">
                        <Check className="mt-[2px] size-[17px] shrink-0 text-[#A88545]" strokeWidth={1.9} />
                        <span className="leading-[1.55] text-[#243B35] !text-[15px] !text-left !h-[20px]">
                          {feature}
                        </span>
                      </li>)}
                  </ul>

                  <div className="![padding:18px_0px_0px_0px] ![margin:80px_0px_0px_0px]">
                    <Button type="button" variant="outline" onClick={scrollToEnquiry} className="h-[50px] w-full border-[#CDBB98] bg-transparent text-[11px] font-bold uppercase tracking-[0.07em] text-[#073F31] hover:bg-[#F7F3E9] hover:border-[#B79A5F]">
                      Claim or Correct Your Profile
                    </Button>
                  </div>
                </div>
              </div>
            </motion.div>

            {}
            <div className="relative hidden items-center justify-center !h-[350px] lg:flex">
              <div className="absolute left-1/2 top-0 h-full w-px -translate-x-1/2 bg-[#D8CEBB]" />
              <div className="relative z-10 flex size-[34px] items-center justify-center rounded-lg bg-[#F7F3E9]">
                <ChevronRight className="size-[18px] text-[#9A793A]" strokeWidth={1.8} />
              </div>
            </div>

            {}
            <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{
            once: true,
            amount: 0.2
          }} className="h-full">
              <div className="overflow-hidden border border-[#D0AE61] bg-[#FFFDF7] rounded-tl-[20px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] !h-[360px]">
                {}
                <div className="flex items-center gap-3 border-b border-[#D5B975] bg-[linear-gradient(90deg,#B48A35_0%,#D7BA74_34%,#C79D42_100%)] px-7 py-4 !justify-center">
                  <Crown className="size-[20px] text-[#FFF7E3]" strokeWidth={1.7} />
                  <h3 className="text-[18px] font-medium leading-none text-[#FFFDF7] md:text-[20px]" style={{
                  fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
                }}>
                    TeeListClub Partner
                  </h3>
                </div>

                <div className="flex h-[calc(100%-65px)] flex-col px-7 py-6 md:px-8 md:py-7">
                  <ul className="space-y-4 !p-0 ![margin:-10px_0px_-10px_0px]">
                    {partnerFeatures.map(feature => <li key={feature} className="flex items-start gap-3 !h-[20px]">
                        <Check className="mt-[2px] size-[17px] shrink-0 text-[#9B7A34]" strokeWidth={1.9} />
                        <span className="text-[15px] leading-[1.55] text-[#243B35] !h-[20px]">{feature}</span>
                      </li>)}
                  </ul>

                  <div className="!h-[90px] !p-0 ![margin:20px_0px_20px_0px]">
                    <Button type="button" onClick={scrollToEnquiry} className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs has-[>svg]:px-3 h-[50px] w-full bg-[#BFFF00] text-[11px] font-bold uppercase tracking-[0.075em] text-[#073F31] transition-all duration-300 ![margin:8px_0px_8px_0px] ![padding:8px_16px_8px_16px] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:-translate-y-[1px] hover:bg-[#CBFF36]">
                      Discuss a Partnership
                    </Button>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {}
          <div className="mt-6 flex justify-center lg:hidden">
            <div className="flex items-center gap-2 text-[#9A793A]">
              <div className="h-px w-10 bg-[#D8CEBB]" />
              <ChevronRight className="size-[16px]" strokeWidth={1.7} />
              <div className="h-px w-10 bg-[#D8CEBB]" />
            </div>
          </div>
        </div>

        {}
        <p className="max-w-[820px] text-center text-[12px] leading-[1.65] text-[#65746D] ![margin:32px_240px_0px_240px]"><span className="!text-sm whitespace-nowrap !text-center !p-0 !m-0">*Basic factual corrections remain free. Partnership covers managed presentation, faster updates and selected commercial opportunities.</span></p>
      </div>
    </section>;
}